import { render, staticRenderFns } from "./TreeArea.vue?vue&type=template&id=6cc83dd0&scoped=true&"
import script from "./TreeArea.vue?vue&type=script&lang=js&"
export * from "./TreeArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc83dd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc83dd0')) {
      api.createRecord('6cc83dd0', component.options)
    } else {
      api.reload('6cc83dd0', component.options)
    }
    module.hot.accept("./TreeArea.vue?vue&type=template&id=6cc83dd0&scoped=true&", function () {
      api.rerender('6cc83dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/view-report/components/TreeArea.vue"
export default component.exports